export const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  formTitle: {
    fontSize: '1rem',
  },
  formGrid: {
    padding: theme.spacing(0),
    marginBottom: '1rem',
  },
  formItemGrid: {
    marginTop: '1rem',
  },
  switchContainer: {
    margin: '0.1rem 0',
    width: '100%',
    justifyContent: 'space-between',
    marginLeft: 0,
    marginRight: 0,
  },
  switchLabel: {
    fontSize: '0.9rem',
    paddingLeft: '0 !important',
    marginLeft: '0 !important',
  },
  previewContainer: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  previewHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  previewIcon: {
    marginRight: theme.spacing(0.3),
    color: theme.palette.grey[600],
    fontSize: '1.4rem',

  },
  previewTitle: {
    fontSize: '0.8rem',
  },
  previewIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  previewChipsContainer: {
    marginLeft: theme.spacing(2),
    display: 'flex',
    color: theme.palette.white,
  },
  previewChip: {
    padding: "0.2rem 0.5rem",
    borderRadius: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    maxWidth: '70px',
    minWidth: '70px',
    minHeight: '21px',
    maxHeight: '21px',
    fontSize: '0.8rem',
    color: theme.palette.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  previewChipGreen: {
    backgroundColor: 'rgba(52, 159, 36, 0.68)',
    border: '1px solid rgba(46, 125, 50, 1)',
    '& .MuiTypography-root': {
      color: 'white',
    },
  },
  previewChipYellow: {
    backgroundColor: 'rgba(255, 212, 0, 0.4)',
    border: '1px solid #F2CE17',
    maxWidth: '90px',
    minWidth: '90px',
    '& .MuiTypography-root': {
      color: '#969595ff',
    },
  },
  previewChipRed: {
    backgroundColor: 'rgba(242, 23, 23, 0.4)',
    border: '1px solid #F21717',
    '& .MuiTypography-root': {
      color: 'white',
    },
  },

  inboundPakInfo: {
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
})